import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "create-drive",
  "use": "create-drive-usage",
  "viewBox": "0 0 15 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 20\" id=\"create-drive\"><path d=\"M9.375.5h-7.5C.839.5.009 1.34.009 2.375l-.009 15c0 1.036.83 1.875 1.866 1.875h11.259c1.036 0 1.875-.84 1.875-1.875V6.125L9.375.5zm1.875 13.125H8.437v2.813H6.563v-2.813H3.75V11.75h2.813V8.937h1.875v2.813h2.812v1.875zM8.437 7.062V1.907l5.157 5.157H8.438z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol